import { render, staticRenderFns } from "./addressForm.vue?vue&type=template&id=561754f8&scoped=true&"
import script from "./addressForm.vue?vue&type=script&lang=js&"
export * from "./addressForm.vue?vue&type=script&lang=js&"
import style0 from "./addressForm.vue?vue&type=style&index=0&id=561754f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561754f8",
  null
  
)

export default component.exports